/**
 * SafetyCheck
 * The SafetyCheck API
 *
 * The version of the OpenAPI document: master-35d84d79-917289
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Reference } from './reference';
import { OrganizationDto } from './organizationDto';


export interface AreYouOkDto { 
    /**
     * The current response, regardless if it was set by user or admin
     */
    status?: AreYouOkDtoStatus;
    /**
     * The given accessCode
     */
    id: string;
    /**
     * Title of the safety check
     */
    title: string;
    /**
     * Customer facing description of the safety check
     */
    description?: string;
    /**
     * Phone number shown to affected person to call for assistance
     */
    assistancePhoneNumber?: string;
    organization: OrganizationDto;
    /**
     * Indicates if the given safety-check is ongoing and accepting responses
     */
    ongoing: boolean;
    /**
     * Time the person was added to the SafetyCheck
     */
    createdAt: string;
    /**
     * Time the current response was set
     */
    updatedAt?: string;
    /**
     * Time the Safety Check was marked as \"done\" (if not it is not ongoing)
     */
    doneAt?: string;
    /**
     * Alerts associated with the SafetyCheck
     */
    alerts: Array<Reference>;
}
export enum AreYouOkDtoStatus {
    Ok = 'ok',
    NeedSupport = 'need-support'
};



